import { BrowserRouter as Router, Routes, Route, } from "react-router-dom";
import Navbar from './Components/Navbar/navbar';
import React from "react";
import Home from "./Pages/Home/Home";
import Footer from "./Components/Footer/footer";
import ContactUs from "./Pages/Contact Us/Contact";
import Team from './Pages/Our Team/Team';
import Register from './Components/Register/register';
import About from "./Pages/About Us/about";
import Bhawishyam from "./Components/Event_Detailed/Bhawishyam";
import Microfest from "./Components/Event_Detailed/Microfest";
import Pharmacist from "./Components/Event_Detailed/Pharmacist_Day";
import Pharmocoviglance from "./Components/Event_Detailed/Pharmocoviglance_Week";
// import Details from './Components/Blog/blog';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/team" element={<Team />} />
          {/* <Route path="/blog" element={<Details />} /> */}
          <Route path="/register" element={<Register />} />
          <Route path="/event/bhawishyam" element={<Bhawishyam />} />
          <Route path="/event/microfest" element={<Microfest />} />
          <Route path="/event/pharmacist-day" element={<Pharmacist />} />
          <Route path="/event/pharmocoviglance-week" element={<Pharmocoviglance />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
